import { Injectable } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(private readonly  dialog: MatDialog) { }

  openConfirmDialog(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      panelClass:'dialog-class',
      data: { message },
    });

    return dialogRef.afterClosed();
  }
}
